/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetUserProfileRequest, TGetUserProfileModel, IMappers, TGetUserProfileResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetUserProfileResponse } from '../../entities/user_profile/GetUserProfileResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetUserProfileModel(parameters: IGetUserProfileRequest): TGetUserProfileModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/get-user-profile/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetUserProfileOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetUserProfileRequest;
}

export async function fetchGetUserProfile<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetUserProfileOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetUserProfileResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetUserProfileModel(parameters),
    config,
  )) as FetchResponse<TGetUserProfileResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetUserProfileResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetUserProfileResponse>;
}
